import React, { Dispatch, SetStateAction } from 'react';
import IconToggle from 'react-scale/components/design-system/IconToggle';
import VerticalSliderButton from 'react-scale/components/scalers/VerticalSliderButton';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { makeStyles } from 'react-scale/components/design-system';
interface ImageAdjustmentButtonProps {
  iconName: FontAwesomeIconProps['icon'];
  toolName: string;
  value: number;
  onAdjust: Dispatch<SetStateAction<number>>;
  adjustmentMultiplier?: number;
  onReset?: () => void;
  onlyShowSlider?: boolean;
}

const useStyles = makeStyles({
  adjustmentButton: {
    marginTop: '4px',
  },
  toolTip: {
    marginBottom: '4px',
  },
});

const ImageAdjustmentButton: React.FC<ImageAdjustmentButtonProps> = props => {
  const classes = useStyles();

  const tooltip = (
    <div>
      <div className={classes.toolTip}>{props.toolName}</div>
    </div>
  );

  const icon = props.iconName;

  const targetOpen = (
    <div className={classes.adjustmentButton}>
      <IconToggle name={props.toolName} tooltip={tooltip} icon={icon} isOn={true} />
    </div>
  );
  const targetClosed = (
    <div className={classes.adjustmentButton}>
      <IconToggle name={props.toolName} tooltip={tooltip} icon={icon} isOn={false} />
    </div>
  );

  return (
    <VerticalSliderButton
      targetOpen={targetOpen}
      targetClosed={targetClosed}
      innerSliderIcon={<FontAwesomeIcon icon={icon} />}
      value={props.value}
      onAdjust={props.onAdjust}
      adjustmentMultiplier={props.adjustmentMultiplier ?? 1}
      onReset={props.onReset}
      onlyShowSlider={props.onlyShowSlider}
    />
  );
};

export default ImageAdjustmentButton;
